import { XMarkIcon } from "@heroicons/react/24/solid";

/**
 * Generic modal wrapper for all modals.
 * Can transclude any custom content.
 * Please use this for all future modals.
 *
 */
export default function ModalGeneric({children, title, callback, className, absolute}) {
	return (
		<div className={`inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50 z-10 text-black ${absolute?'absolute':'fixed'}`}>
			<div className={`w-1/2 p-6 bg-white border-2 border-black border-t-4 z-10 min-w-fit max-w-2xl normal-case break-word ${className}`}>
				<div className="flex items-center justify-between">
					<h3 className="text-2xl">{title || "Alert"}</h3>
					{callback && (
						<div className="flex justify-end">
							<XMarkIcon className="h-8 w-8 text-gray-500 cursor-pointer" onClick={callback}/>
						</div>
					)}
				</div>
				{children}
			</div>
		</div>
	);
}